import RootRollbarMixin from 'GroomyRoot/mixins/Rollbar.js'

export default {
    mixins: [RootRollbarMixin]
}
